
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCashCouponTypeSerialDialog extends Serenity.EntityDialog<PsCashCouponTypeSerialRow, any> {
        protected getFormKey() { return PsCashCouponTypeSerialForm.formKey; }
        protected getIdProperty() { return PsCashCouponTypeSerialRow.idProperty; }
        protected getLocalTextPrefix() { return PsCashCouponTypeSerialRow.localTextPrefix; }
        protected getNameProperty() { return PsCashCouponTypeSerialRow.nameProperty; }
        protected getService() { return PsCashCouponTypeSerialService.baseUrl; }
        protected getDeletePermission() { return PsCashCouponTypeSerialRow.deletePermission; }
        protected getInsertPermission() { return PsCashCouponTypeSerialRow.insertPermission; }
        protected getUpdatePermission() { return PsCashCouponTypeSerialRow.updatePermission; }

        protected form = new PsCashCouponTypeSerialForm(this.idPrefix);

    }
}